// extracted by mini-css-extract-plugin
export default {"btn_center":"SidebarTools_btn_center__IUfRt","analysebox_wrapper":"SidebarTools_analysebox_wrapper__CV3Fy"};